var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DomHelper } from "./domHelper";
import { getBackendData, getBackendFile, sendBackendData } from "./xhrbackend";
import { Util } from "./util";
import { DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from './appCardDefault';
import { DataStore } from "./dataStore";
import { handleGradeShow } from "./appSchoolAdminGrade";
let ds = new DataStore();
const functionList = [
    { label: "Klassenzuweisung", help: "Zuordnung von Lernenden zu Klassen.", type: "pupil" },
    { label: "Klassen", help: "Pflege der Grunddaten für Klassen, Name, Gültigkeit etc.", type: "classes" },
    { label: "Gruppen", help: "Zuordnung von Lernenden zu Gruppen", type: "groups" },
    { label: "Lehrkräfte", help: "Zuordnung von Lehrkräften zu Klassen", type: "teacher" },
];
export function appSchoolAdminRender(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appSchoolAdminRender");
    const additionalClassList = [];
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    let content = "";
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList, null, (event) => {
        handleClickOpen(event, username, bearerToken, userResponse.odDeskPreferences);
    });
}
export function getSchoolAdminMainStructure(fullScreenNode, additionalClassList) {
    DomHelper.appendNode(fullScreenNode, 'section', additionalClassList, [], "", "odSchoolSelector");
    DomHelper.appendNode(fullScreenNode, 'section', additionalClassList, [], "", "odSchoolFunctionSelector");
    DomHelper.appendNode(fullScreenNode, 'section', additionalClassList, [], "", "odSchoolClassSelector");
    DomHelper.appendNode(fullScreenNode, 'section', additionalClassList, [], "", "odSchoolMessage");
    DomHelper.appendNode(fullScreenNode, 'section', additionalClassList, [], "", "odSchoolGrid");
}
function handleClickOpen(event, username, bearerToken, userPreferences) {
    const additionalClassList = [];
    const appGroupNode = document.getElementById('appGroups');
    if (appGroupNode)
        appGroupNode.classList.add('disabled');
    const fullScreenNode = document.getElementById('appFullscreen');
    if (fullScreenNode) {
        fullScreenNode.classList.remove('disabled');
        createButtonClose(fullScreenNode, username, bearerToken, userPreferences);
        DomHelper.appendNode(fullScreenNode, 'h1', additionalClassList, [], "Schulverwaltung");
        let nodePupilSearch = DomHelper.appendNode(fullScreenNode, 'section', additionalClassList, [], "", "odSchoolPupilSearch");
        appPartPupilSearchBoxRender(nodePupilSearch, username, userPreferences, bearerToken);
        getSchoolAdminMainStructure(fullScreenNode, additionalClassList);
    }
    getBackendData(username, "/school/", "GET", "application/json", bearerToken, function (response) {
        const responseData = JSON.parse(response.target.response);
        const selectorNode = document.getElementById('odSchoolSelector');
        if (selectorNode)
            appPartSchoolSelectorRender(selectorNode, username, userPreferences, responseData, bearerToken);
    });
}
function handleFunctionSelection(event, username, bearerToken) {
    if (event && event.target) {
        let target = event.target;
        const buttonNode = DomHelper.getFirstParentWithClass(target, "rudi-school-class-btn");
        const gridNode = document.getElementById("odSchoolGrid");
        let schoolUUID = buttonNode.getAttribute("schoolid") + "";
        let type = buttonNode.getAttribute("id");
        if (type)
            updateFunctionButtonActiveState(type);
        if (type === "pupil") {
            const classSelectNode = document.getElementById('odSchoolClassSelector');
            if (classSelectNode)
                classSelectNode.innerHTML = '';
            getBackendData(username, "/school/" + schoolUUID + "/", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                const classes = responseData[0].classes;
                const schoolUUID = responseData[0].id;
                if (schoolUUID != "empty") {
                    getBackendData(username, "/school/" + schoolUUID + "/pupil/", "GET", "application/json", bearerToken, function (response) {
                        const responseData = JSON.parse(response.target.response);
                        appPartFunctionRender(username, schoolUUID, classes, responseData, bearerToken, "pupil");
                        appPartSchoolGridRender(schoolUUID, classes, responseData, bearerToken);
                    });
                }
            });
        }
        else if (type === "teacher") {
            const classSelectNode = document.getElementById('odSchoolClassSelector');
            if (classSelectNode)
                classSelectNode.innerHTML = '';
            getBackendData(username, "/school/" + schoolUUID + "/", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                const classes = responseData[0].classes;
                const schoolUUID = responseData[0].id;
                if (schoolUUID != "empty") {
                    getBackendData('', "/school/" + schoolUUID + "/teachers/all", "GET", "application/json", bearerToken, function (response) {
                        const responseData = JSON.parse(response.target.response);
                        appPartFunctionRender(username, schoolUUID, classes, responseData, bearerToken, "teacher");
                        appPartSchoolTeacherGridRender(schoolUUID, classes, responseData, bearerToken);
                    });
                }
            });
        }
        else if (type === "classes") {
            const classSelectNode = document.getElementById('odSchoolClassSelector');
            if (classSelectNode)
                classSelectNode.innerHTML = '';
            getBackendData(username, "/school/" + schoolUUID + "/", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                const classes = responseData[0].classes;
                const schoolUUID = responseData[0].id;
                appPartClassGridRender(schoolUUID, classes, bearerToken);
            });
        }
        else if (type === "groups") {
            const classSelectNode = document.getElementById('odSchoolClassSelector');
            if (classSelectNode)
                classSelectNode.innerHTML = '';
            getBackendData('', "/school/" + schoolUUID + "/classes", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                const classes = responseData;
                appPartClassSelectorRender(classSelectNode, username, schoolUUID, classes, bearerToken);
            });
        }
    }
}
function appPartSchoolSelectorRender(injectNode, username, userPreferences, data, bearerToken) {
    DomHelper.appendNode(injectNode, 'h3', [], [], "Klassenzuordnung");
    const schoolNode = DomHelper.appendNode(injectNode, 'div', ['form-group']);
    DomHelper.appendNode(schoolNode, 'label', ['form-label', 'mb-0', 'mt-2'], [{ attr: 'for', value: 'rudi-tt-form-school' }], "Wählen Sie eine Schule");
    const selectNode = DomHelper.appendNode(schoolNode, 'select', ['form-select'], [{ attr: 'id', value: 'rudi-admin-form-school' }]);
    DomHelper.appendNode(selectNode, 'option', [], [
        { attr: 'value', value: "empty" }
    ], "-- Bitte Schule wählen --- ");
    for (let school of data) {
        DomHelper.appendNode(selectNode, 'option', [], [
            { attr: 'value', value: school.id }
        ], school.longname);
    }
    selectNode.addEventListener('change', function (event) {
        const selectNode = document.getElementById('rudi-admin-form-school');
        if (selectNode) {
            console.log(selectNode.value);
        }
        getBackendData(username, "/school/" + selectNode.value + "/", "GET", "application/json", bearerToken, function (response) {
            const responseData = JSON.parse(response.target.response);
            const classes = responseData[0].classes;
            const schoolUUID = responseData[0].id;
            if (schoolUUID != "empty") {
                getBackendData(username, "/school/" + schoolUUID + "/pupil/", "GET", "application/json", bearerToken, function (response) {
                    const responseData = JSON.parse(response.target.response);
                    appPartFunctionRender(username, schoolUUID, classes, responseData, bearerToken, "pupil");
                    appPartSchoolGridRender(schoolUUID, classes, responseData, bearerToken);
                });
            }
        });
    });
}
function appPartClassSelectorRender(injectNode, username, schoolUUID, data, bearerToken) {
    DomHelper.appendNode(injectNode, 'h3', [], [], "Gruppenzuordnung");
    const messageNode = document.getElementById('odSchoolMessage');
    if (messageNode)
        messageNode.innerHTML = '';
    const odSchoolGridNode = document.getElementById('odSchoolGrid');
    if (odSchoolGridNode)
        odSchoolGridNode.innerHTML = '';
    const schoolNode = DomHelper.appendNode(injectNode, 'div', ['form-group']);
    DomHelper.appendNode(schoolNode, 'label', ['form-label', 'mb-0', 'mt-2'], [{ attr: 'for', value: 'rudi-tt-form-school' }], "Wählen Sie eine Klasse");
    const selectNode = DomHelper.appendNode(schoolNode, 'select', ['form-select'], [{ attr: 'id', value: 'rudi-admin-form-class' }]);
    DomHelper.appendNode(selectNode, 'option', [], [
        { attr: 'value', value: "empty" }
    ], "-- Bitte Klasse wählen --- ");
    const sortedClasses = sortClassesByShortname(data);
    const activeClasses = Util.filterActiveClasses(sortedClasses);
    for (let classItem of activeClasses) {
        DomHelper.appendNode(selectNode, 'option', [], [
            { attr: 'value', value: classItem.id }
        ], classItem.longname);
    }
    selectNode.addEventListener('change', function (event) {
        getBackendData('', `/school/${schoolUUID}/class/${selectNode.value}/groups`, "GET", "application/json", bearerToken, function (response) {
            const responseData = JSON.parse(response.target.response);
            const groups = responseData;
            if (groups.s != "empty") {
                getBackendData('', `/school/${schoolUUID}/class/${selectNode.value}/pupils`, "GET", "application/json", bearerToken, function (response) {
                    const responseData = JSON.parse(response.target.response);
                    appPartSchoolGridClassRender(schoolUUID, groups, responseData, bearerToken);
                });
            }
        });
    });
}
function addPupilDetailRow(tableNode, cssClass, label, value, uri) {
    let rowNode = DomHelper.appendNode(tableNode, 'tr', []);
    DomHelper.appendNode(rowNode, 'td', cssClass, [], label);
    let contentNode = DomHelper.appendNode(rowNode, 'td', cssClass, []);
    DomHelper.appendNode(contentNode, 'span', [], [], value ? value : "-");
    if (uri) {
        DomHelper.appendIconWithLink(contentNode, ['fa-light', 'fa-link'], [{ attr: 'target', value: 'blank' }], uri);
    }
}
function addPupilDetail(parentNode, pupil, singlemode = false) {
    var _a, _b, _c, _d, _e, _f;
    let detailNode;
    if (singlemode) {
        detailNode = parentNode;
    }
    else {
        detailNode = DomHelper.appendNode(parentNode, 'details', []);
        DomHelper.appendNode(detailNode, 'summary', [], [], 'Details einblenden');
    }
    const tableNode = DomHelper.appendNode(detailNode, 'table', []);
    addPupilDetailRow(tableNode, [], "E-Mail", pupil.mail);
    addPupilDetailRow(tableNode, [], "Wohnort", `${pupil.odPLZ} ${pupil.odCity}`);
    addPupilDetailRow(tableNode, [], "AusweisNr", pupil.odAusweisSchuelerNr, `https://open-diakonie.de/desk/ausweis.html?id=${pupil.odAusweisSchuelerNr}`);
    addPupilDetailRow(tableNode, [], "Schule", (_a = pupil.odPupil) === null || _a === void 0 ? void 0 : _a.schoolname);
    addPupilDetailRow(tableNode, [], "Klasse", (_b = pupil.odPupil) === null || _b === void 0 ? void 0 : _b.odClassName);
    addPupilDetailRow(tableNode, [], "Notfallkontakt", (_c = pupil.odPupil) === null || _c === void 0 ? void 0 : _c.odEmergencyContact);
    if (pupil.pwdAccountLockedTime == '000001010000Z') {
        addPupilDetailRow(tableNode, ['error'], "Status", "In SAP BOM gesperrt. Kann sich nicht an unseren Systemen anmelden.");
    }
    if (((_d = pupil.odPupil) === null || _d === void 0 ? void 0 : _d.odClassUUID) != undefined && ((_e = pupil.odPupil) === null || _e === void 0 ? void 0 : _e.schoolUUID) != ((_f = pupil.odPupil) === null || _f === void 0 ? void 0 : _f.odClassSchoolUUID)) {
        addPupilDetailRow(tableNode, ['error'], "Fehler", "Zuordnung zu einer Klasse einer anderen Schule.");
    }
}
function appPartPupilSearchResultRender(resultNode, responseData, bearerToken) {
    var _a, _b, _c;
    resultNode.innerHTML = "";
    resultNode.scrollIntoView({ behavior: 'smooth' });
    if (responseData.length < 1) {
        resultNode.innerHTML = "Ihre Suche ergab keine Treffer";
        return;
    }
    if (responseData.status == "error") {
        resultNode.innerHTML = responseData.message;
        return;
    }
    DomHelper.appendNode(resultNode, 'div', [], [], `Ihre Suche ergab ${responseData.length} Treffer:`);
    for (let pupil of responseData) {
        let pupilNode = DomHelper.appendNode(resultNode, 'div', ['rudi-pupil-result']);
        if (pupil.pwdAccountLockedTime == '000001010000Z') {
            DomHelper.appendNode(pupilNode, 'i', ['fa-light', 'fa-lock', 'error']);
        }
        if (((_a = pupil.odPupil) === null || _a === void 0 ? void 0 : _a.odClassUUID) != undefined && ((_b = pupil.odPupil) === null || _b === void 0 ? void 0 : _b.schoolUUID) != ((_c = pupil.odPupil) === null || _c === void 0 ? void 0 : _c.odClassSchoolUUID)) {
            DomHelper.appendNode(pupilNode, 'i', ['fa-light', 'fa-warn', 'warn']);
        }
        DomHelper.appendNode(pupilNode, 'span', ['em'], [], `${pupil.displayName} ${pupil.cn}`);
        addPupilDetail(pupilNode, pupil, responseData.length == 1);
    }
}
function appPartPupilSearchBoxRender(injectNode, username, userPreferences, bearerToken) {
    DomHelper.appendNode(injectNode, 'h3', [], [], "Personensuche");
    const formNode = DomHelper.appendNode(injectNode, 'form', [], [
        { attr: 'id', value: 'rudi-admin-pupil-search-form' },
        { attr: 'enctype', value: 'multipart/form-data' },
        { attr: 'method', value: 'POST' }
    ]);
    const pupilsearchNode = DomHelper.appendNode(formNode, 'div', ['form-group']);
    DomHelper.appendInputText(pupilsearchNode, "rudi-admin-pupil-search-form", ['form-control'], [{
            attr: 'id',
            value: 'rudi-pupil-search-mixed'
        }], 'mixed');
    const detailNode = DomHelper.appendNode(pupilsearchNode, 'div', ['disabled'], [{
            attr: 'id',
            value: 'rudi-pupil-search-extended'
        }]);
    DomHelper.appendInputText(detailNode, "rudi-admin-pupil-search-form", ['form-control'], [{
            attr: 'id',
            value: 'rudi-pupil-search-cn'
        }], 'cn', 'GP-Nummer');
    DomHelper.appendInputText(detailNode, "rudi-admin-pupil-search-form", ['form-control'], [{
            attr: 'id',
            value: 'rudi-pupil-search-sn'
        }], 'sn', 'Nachname');
    DomHelper.appendInputText(detailNode, "rudi-admin-pupil-search-form", ['form-control'], [{
            attr: 'id',
            value: 'rudi-pupil-search-givenName'
        }], 'givenName', 'Vorname');
    let submitNode = DomHelper.appendNode(pupilsearchNode, 'section', ['rudi-form-input-group'], []);
    let buttonNode = DomHelper.appendNode(submitNode, 'button', ['btn', 'btn-primary', 'mt-2', 'me-2'], [{
            attr: 'type',
            value: 'submit'
        }]);
    DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-search']);
    DomHelper.appendNode(buttonNode, 'span', [], [], 'Suchen');
    let buttonExtendNode = DomHelper.appendNode(submitNode, 'button', ['btn', 'btn-primary', 'mt-2', 'me-2'], [{
            attr: 'type',
            value: 'submit'
        }]);
    DomHelper.appendNode(buttonExtendNode, 'i', ['fa-light', 'fa-filter']);
    DomHelper.appendNode(buttonExtendNode, 'span', [], [], 'Erweitern');
    buttonExtendNode.addEventListener('click', function (event) {
        detailNode.classList.toggle('disabled');
    });
    let resultNode = DomHelper.appendNode(injectNode, 'section', [], [], '', 'rudi-admin-pupil-search-result');
    formNode.addEventListener('submit', function (event) {
        event.preventDefault();
        const mixed = document.getElementById('rudi-admin-pupil-search-form-mixed').value;
        const cn = document.getElementById('rudi-admin-pupil-search-form-cn').value;
        const sn = document.getElementById('rudi-admin-pupil-search-form-sn').value;
        const givenName = document.getElementById('rudi-admin-pupil-search-form-givenname').value;
        const params = new URLSearchParams();
        if (cn)
            params.append('cn', cn);
        if (sn)
            params.append('sn', sn);
        if (givenName)
            params.append('givenName', givenName);
        if (mixed)
            params.append('mixed', mixed);
        const queryString = params.toString();
        const url = `/school/pupil/search?${queryString}`;
        try {
            getBackendData('', url, 'GET', 'application/json', bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                appPartPupilSearchResultRender(resultNode, responseData, bearerToken);
            });
        }
        catch (e) {
            if (resultNode) {
                resultNode.innerHTML = e.toString();
            }
        }
    });
}
function renderGroupUpdate(groupItem, schoolid, bearerToken) {
    const btnNode = document.getElementById(groupItem.id);
    btnNode.innerHTML = groupItem.shortname;
    const groupNode = btnNode.parentNode;
    renderGroupEditButton(groupNode, groupItem.classid, groupItem, schoolid, bearerToken);
}
function renderClassUpdate(classItem, schoolid, bearerToken) {
    const trNode = document.getElementById(classItem.id);
    if (trNode) {
        trNode.innerHTML = "";
        addClassInfo(trNode, schoolid, classItem, bearerToken);
    }
}
function renderClassCreate(classItem, schoolUUID, bearerToken) {
    const tbodyNode = document.getElementById('rudi-class-table-body');
    if (tbodyNode) {
        renderGridRowClass(tbodyNode, classItem, schoolUUID, bearerToken);
    }
}
function renderGroupCreate(groupItem, schoolUUID, classUUID, bearerToken) {
    const tbodyNode = document.getElementById(`groups-${classUUID}`);
    if (tbodyNode) {
        renderGroupEditButton(tbodyNode, classUUID, groupItem, schoolUUID, bearerToken);
    }
}
function creatClassForm(bearerToken, formNode, schoolid, classItem, modalNode, shortnameReadonly = true) {
    DomHelper.appendInputText(formNode, "id", [], [], 'id', '', classItem.id, [{
            attr: "readonly",
            value: 'true'
        }, { attr: "hidden", value: 'true' }]);
    let shortnameAttr = shortnameReadonly ? [{
            attr: "readonly",
            value: 'true'
        }] : [{
            attr: 'pattern',
            value: '[-A-Za-z0-9]+'
        },
        {
            attr: 'title',
            value: 'Darf nur aus Buchstaben und Zahlen ohne Leerzeichen bestehen.'
        }];
    DomHelper.appendInputText(formNode, "shortname", [], [], 'shortname', 'Kürzel', classItem.shortname, shortnameAttr);
    DomHelper.appendInputText(formNode, "longname", [], [], 'longname', 'Bezeichnung (lang) wird verwendet z.B. Chatraum Name. Darf deshalb keine Leerzeichen enthalten.', classItem.longname, [{
            attr: 'pattern',
            value: '[-A-Za-z0-9]+'
        }]);
    DomHelper.appendInputText(formNode, "von", [], [], 'von', 'Beginn', Util.isoString2DateString(classItem.von), []);
    DomHelper.appendInputText(formNode, "bis", [], [], 'bis', 'Ende', classItem.bis == "" || classItem.bis == null ? "" : Util.isoString2DateString(classItem.bis), []);
    let teacherNameKeys = [];
    if (classItem.teachers) {
        for (let teacher of classItem.teachers) {
            let odNK = {
                id: teacher.cn,
                name: teacher.displayName
            };
            teacherNameKeys.push(odNK);
        }
    }
    DomHelper.appendMultiNameSelect(formNode, "teacher", [], [], 'teacher', 'Lehrkräfte', bearerToken, schoolid, classItem.id, teacherNameKeys);
    const section = DomHelper.appendNode(formNode, 'section', ['rudi-form-input-group'], []);
    const buttonCloseNode = DomHelper.appendNode(section, "button", ['btn', 'btn-secondary'], [{
            attr: "classid",
            value: classItem.id
        }], '');
    DomHelper.appendNode(buttonCloseNode, 'i', ['fa-light', 'fa-circle-xmark']);
    DomHelper.appendNode(buttonCloseNode, 'span', [], [], 'Schließen');
    buttonCloseNode.addEventListener('submit', function (event) {
        event.preventDefault();
        modalNode.style.display = 'none';
    });
    const nodeSearchBox = document.getElementById('rudi-multi-searchbox-input');
    const resultArea = document.getElementById('rudi-multi-searchbox-result');
    if (nodeSearchBox && resultArea) {
        nodeSearchBox.addEventListener('change', function (event) {
            handleSearchBox(bearerToken, schoolid, classItem.id, nodeSearchBox, resultArea);
        });
    }
    return section;
}
function creatGroupForm(bearerToken, formNode, classid, groupItem, modalNode, shortnameReadonly = true) {
    DomHelper.appendInputText(formNode, "id", [], [], 'id', '', groupItem.id, [{
            attr: "readonly",
            value: 'true'
        }, { attr: "hidden", value: 'true' }]);
    let shortnameAttr = shortnameReadonly ? [{
            attr: "readonly",
            value: 'true'
        }] : [{
            attr: 'pattern',
            value: '[-A-Za-z0-9]+'
        },
        {
            attr: 'title',
            value: 'Darf nur aus Buchstaben und Zahlen ohne Leerzeichen bestehen.'
        }];
    DomHelper.appendInputText(formNode, "shortname", [], [], 'shortname', 'Kürzel', groupItem.shortname, shortnameAttr);
    DomHelper.appendInputText(formNode, "longname", [], [], 'longname', 'Bezeichnung (lang) wird verwendet z.B. Chatraum Name', groupItem.longname, []);
    DomHelper.appendInputText(formNode, "von", [], [], 'von', 'Beginn', Util.isoString2DateString(groupItem.von), []);
    DomHelper.appendInputText(formNode, "bis", [], [], 'bis', 'Ende', groupItem.bis == "" || groupItem.bis == null ? "" : Util.isoString2DateString(groupItem.bis), []);
    const section = DomHelper.appendNode(formNode, 'section', ['rudi-form-input-group'], []);
    const buttonCloseNode = DomHelper.appendNode(section, "button", ['btn', 'btn-secondary'], [{
            attr: "classid",
            value: groupItem.id
        }], '');
    DomHelper.appendNode(buttonCloseNode, 'i', ['fa-light', 'fa-circle-xmark']);
    DomHelper.appendNode(buttonCloseNode, 'span', [], [], 'Schließen');
    buttonCloseNode.addEventListener('click', function (event) {
        event.preventDefault();
        modalNode.style.display = 'none';
    });
    return section;
}
function handleSearchBox(bearerToken, schoolid, classid, searchBox, resultArea) {
    const query = searchBox.value;
    if (query.length < 3) {
        resultArea.innerHTML = '';
        return;
    }
    resultArea.innerHTML = '';
    getBackendData('', `/school/teachers/search/?search=${query}`, "GET", "application/json", bearerToken, function (response) {
        const responseData = JSON.parse(response.target.response);
        for (let teacher of responseData) {
            const nodeTeacher = DomHelper.appendNode(resultArea, 'div', ['rudi-search-add-item'], [], teacher.displayName);
            DomHelper.appendNode(nodeTeacher, 'i', ['fa-light', 'fa-user-plus'], []);
            nodeTeacher.addEventListener('click', function (event) {
                searchBox.value = "";
                resultArea.innerHTML = "";
                handleAddTeacher2Class(bearerToken, schoolid, classid, teacher.cn, teacher.displayName);
            });
        }
    });
}
function handleAddTeacher2Class(bearerToken, schoolid, classid, teacherCN, teacherDisplayNAme) {
    sendBackendData('', `/school/${schoolid}/class/${classid}/teacher/${teacherCN}`, 'PUT', 'application/json', bearerToken, {}, (response) => {
        const responseData = JSON.parse(response.target.response);
        handleUpdateAddTeacher2Class(bearerToken, schoolid, classid, teacherCN, teacherDisplayNAme);
    });
}
function handleUpdateAddTeacher2Class(bearerToken, schoolid, classid, teacherCN, teacherDisplayNAme) {
    const nodeResult = document.getElementById('rudi-form-multiName-group-selected');
    DomHelper.renderNameKeyobject(nodeResult, {
        id: teacherCN,
        name: teacherDisplayNAme
    }, bearerToken, schoolid, classid);
}
function handleClassCreate(schoolid, bearerToken, event) {
    const modalNode = document.getElementById('rudi-modal');
    const modalContentNode = document.getElementById('rudi-modal-content');
    const today = new Date();
    const vonString = today.toISOString();
    const classItem = {
        id: '',
        longname: 'Neue Klasse',
        shortname: 'nk',
        von: vonString,
        groups: []
    };
    if (modalNode && modalContentNode) {
        DomHelper.showModal(modalNode);
        const titleNode = document.getElementById('rudi-modal-title');
        if (titleNode)
            titleNode.innerHTML = "Neue Klasse anlegen";
        const formNode = document.getElementById('rudi-modal-form');
        if (formNode) {
            formNode.innerHTML = "";
            const section = creatClassForm(bearerToken, formNode, schoolid, classItem, modalNode, false);
            const buttonSafeNode = DomHelper.appendNode(section, "button", ['btn', 'btn-secondary'], [{
                    attr: "classid",
                    value: classItem.id
                }], '');
            DomHelper.appendNode(buttonSafeNode, 'i', ['fa-light', 'fa-cloud-arrow-up']);
            DomHelper.appendNode(buttonSafeNode, 'span', [], [], 'Klasse speichern');
            buttonSafeNode.addEventListener('click', function (event) {
                event.preventDefault();
                const formData = new FormData(formNode);
                let schoolClass = {
                    id: formData.get('id') ? formData.get('id') : '',
                    longname: formData.get('longname') ? formData.get('longname') : '',
                    shortname: formData.get('shortname') ? formData.get('shortname') : '',
                    von: formData.get('von') ? Util.string2IsoString(formData.get('von')) : '',
                    bis: formData.get('bis') ? Util.string2IsoString(formData.get('bis')) : ''
                };
                modalNode.style.display = 'none';
                sendBackendData('', `/school/${schoolid}/class/`, 'POST', 'application/json', bearerToken, schoolClass, (response) => {
                    const responseData = JSON.parse(response.target.response);
                    renderClassCreate(responseData, schoolid, bearerToken);
                });
            });
        }
    }
}
function handleClassEdit(schoolid, classItem, bearerToken, event) {
    const modalNode = document.getElementById('rudi-modal');
    const modalContentNode = document.getElementById('rudi-modal-content');
    if (modalNode && modalContentNode) {
        DomHelper.showModal(modalNode);
        const titleNode = document.getElementById('rudi-modal-title');
        if (titleNode)
            titleNode.innerHTML = "Klasse bearbeiten";
        const formNode = document.getElementById('rudi-modal-form');
        if (formNode) {
            formNode.innerHTML = "";
            const section = creatClassForm(bearerToken, formNode, schoolid, classItem, modalNode);
            const buttonSafeNode = DomHelper.appendNode(section, "button", ['btn', 'btn-secondary'], [{
                    attr: "classid",
                    value: classItem.id
                }], '');
            DomHelper.appendNode(buttonSafeNode, 'i', ['fa-light', 'fa-cloud-arrow-up']);
            DomHelper.appendNode(buttonSafeNode, 'span', [], [], 'Klasse speichern');
            buttonSafeNode.addEventListener('click', function (event) {
                event.preventDefault();
                const formData = new FormData(formNode);
                let schoolClass = {
                    id: formData.get('id') ? formData.get('id') : '',
                    longname: formData.get('longname') ? formData.get('longname') : '',
                    shortname: formData.get('shortname') ? formData.get('shortname') : '',
                    von: formData.get('von') ? Util.string2IsoString(formData.get('von')) : '',
                    bis: formData.get('bis') ? Util.string2IsoString(formData.get('bis')) : ''
                };
                modalNode.style.display = 'none';
                sendBackendData('', `/school/${schoolid}/class/${classItem.id}`, 'PUT', 'application/json', bearerToken, schoolClass, (response) => {
                    const responseData = JSON.parse(response.target.response);
                    renderClassUpdate(responseData, schoolid, bearerToken);
                });
            });
        }
    }
}
function handleClassPrintList(schoolid, classItem, bearerToken, event) {
    getBackendFile('', `/school/${schoolid}/class/${classItem.id}/pdf`, 'GET', 'application/pdf', bearerToken, (response) => __awaiter(this, void 0, void 0, function* () {
        if (response.target.status != 200) {
            alert('Fehler beim Laden der Klassenliste');
            return;
        }
        const blob = response.target.response;
        console.log(blob);
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `${classItem.shortname}.pdf`;
        link.click();
        URL.revokeObjectURL(downloadUrl);
    }));
}
function handleClassCSVList(schoolid, classItem, bearerToken, event) {
    getBackendFile('', `/school/${schoolid}/class/${classItem.id}/csv`, 'GET', 'text/csv', bearerToken, (response) => __awaiter(this, void 0, void 0, function* () {
        if (response.target.status != 200) {
            alert('Fehler beim Laden der Klassenliste');
            return;
        }
        const blob = new Blob([response.target.response], { type: 'text/csv;charset=utf-8;' });
        console.log(blob);
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `${classItem.shortname}.csv`;
        link.click();
        URL.revokeObjectURL(downloadUrl);
    }));
}
function handleGroupEdit(schoolid, classid, groupItem, bearerToken, event) {
    const modalNode = document.getElementById('rudi-modal');
    const modalContentNode = document.getElementById('rudi-modal-content');
    if (modalNode && modalContentNode) {
        DomHelper.showModal(modalNode);
        const titleNode = document.getElementById('rudi-modal-title');
        if (titleNode)
            titleNode.innerHTML = "Klasse bearbeiten";
        const formNode = document.getElementById('rudi-modal-form');
        if (formNode) {
            formNode.innerHTML = "";
            const section = creatGroupForm(bearerToken, formNode, classid, groupItem, modalNode);
            const buttonSafeNode = DomHelper.appendNode(section, "button", ['btn', 'btn-secondary'], [{
                    attr: "group",
                    value: groupItem.id
                }], '');
            DomHelper.appendNode(buttonSafeNode, 'i', ['fa-light', 'fa-cloud-arrow-up']);
            DomHelper.appendNode(buttonSafeNode, 'span', [], [], 'Gruppe speichern');
            buttonSafeNode.addEventListener('click', function (event) {
                event.preventDefault();
                const formData = new FormData(formNode);
                let schoolClass = {
                    id: formData.get('id') ? formData.get('id') : '',
                    longname: formData.get('longname') ? formData.get('longname') : '',
                    shortname: formData.get('shortname') ? formData.get('shortname') : '',
                    von: formData.get('von') ? Util.string2IsoString(formData.get('von')) : '',
                    bis: formData.get('bis') ? Util.string2IsoString(formData.get('bis')) : ''
                };
                modalNode.style.display = 'none';
                sendBackendData('', `/school/${schoolid}/class/${classid}/group/${groupItem.id}`, 'PUT', 'application/json', bearerToken, schoolClass, (response) => {
                    const responseData = JSON.parse(response.target.response);
                    renderGroupUpdate(responseData, schoolid, bearerToken);
                });
            });
        }
    }
}
function handleAddGroup2Class(schoolid, classid, bearerToken, event) {
    const modalNode = document.getElementById('rudi-modal');
    const modalContentNode = document.getElementById('rudi-modal-content');
    const today = new Date();
    const vonString = today.toISOString();
    const groupItem = {
        id: '',
        classid: classid,
        longname: 'Neue Gruppe',
        shortname: 'ng',
        von: vonString,
        pupils: []
    };
    if (modalNode && modalContentNode) {
        DomHelper.showModal(modalNode);
        const titleNode = document.getElementById('rudi-modal-title');
        if (titleNode)
            titleNode.innerHTML = "Gruppe bearbeiten";
        const formNode = document.getElementById('rudi-modal-form');
        if (formNode) {
            formNode.innerHTML = "";
            const section = creatGroupForm(bearerToken, formNode, schoolid, groupItem, modalNode, false);
            const buttonSafeNode = DomHelper.appendNode(section, "button", ['btn', 'btn-secondary'], [{
                    attr: "classid",
                    value: groupItem.id
                }], '');
            DomHelper.appendNode(buttonSafeNode, 'i', ['fa-light', 'fa-cloud-arrow-up']);
            DomHelper.appendNode(buttonSafeNode, 'span', [], [], 'Gruppe speichern');
            buttonSafeNode.addEventListener('click', function (event) {
                event.preventDefault();
                const formData = new FormData(formNode);
                let schoolGroup = {
                    id: formData.get('id') ? formData.get('id') : '',
                    longname: formData.get('longname') ? formData.get('longname') : '',
                    shortname: formData.get('shortname') ? formData.get('shortname') : '',
                    von: formData.get('von') ? Util.string2IsoString(formData.get('von')) : '',
                    bis: formData.get('bis') ? Util.string2IsoString(formData.get('bis')) : ''
                };
                modalNode.style.display = 'none';
                sendBackendData('', `/school/${schoolid}/class/${classid}/group`, 'POST', 'application/json', bearerToken, schoolGroup, (response) => {
                    const responseData = JSON.parse(response.target.response);
                    renderGroupCreate(responseData, schoolid, classid, bearerToken);
                });
            });
        }
    }
}
function renderGroupEditButton(groupNode, classid, group, schoolid, bearerToken) {
    const buttonNode = DomHelper.appendNode(groupNode, "button", [], [{
            attr: "classid",
            value: classid
        }, { attr: "groupid", value: group.id }], group.shortname);
    buttonNode.addEventListener('click', function (event) {
        handleGroupEdit(schoolid, classid, group, bearerToken, event);
    });
}
function addClassInfo(trNode, schoolid, classItem, bearerToken) {
    const tdEditNode = DomHelper.appendNode(trNode, "td", [], []);
    const iNode = DomHelper.appendNode(tdEditNode, 'i', ['fa-light', 'fa-edit'], [{
            attr: 'schoolid',
            value: schoolid
        }], "", classItem.id);
    DomHelper.addToolTip(iNode, "Klasse bearbeiten", "Klasse_bearbeiten");
    const iNodePrint = DomHelper.appendNode(tdEditNode, 'i', ['fa-light', 'fa-print'], [{
            attr: 'schoolid',
            value: schoolid
        }], "", classItem.id);
    DomHelper.addToolTip(iNodePrint, "Klassenliste als PDF laden", "Klassenliste_als_PDF_laden");
    const iNodeCSV = DomHelper.appendNode(tdEditNode, 'i', ['fa-light', 'fa-file-csv'], [{
            attr: 'schoolid',
            value: schoolid
        }], "", classItem.id);
    DomHelper.addToolTip(iNodeCSV, "Klassenliste als CSV laden", "Klassenliste_als_CSV_laden");
    DomHelper.appendNode(trNode, "td", [], [], classItem.shortname);
    DomHelper.appendNode(trNode, "td", [], [], classItem.longname);
    DomHelper.appendNode(trNode, "td", [], [], Util.isoString2DateString(classItem.von));
    DomHelper.appendNode(trNode, "td", [], [], classItem.bis ? Util.isoString2DateString(classItem.bis) : "--");
    const groupNode = DomHelper.appendNode(trNode, "td", [], [], '', `groups-${classItem.id}`);
    const newGroupNode = DomHelper.appendNode(groupNode, 'i', ['fa-light', 'fa-users-medical'], [{
            attr: 'schoolid',
            value: schoolid
        }], "", classItem.id);
    for (let group of classItem.groups) {
        renderGroupEditButton(groupNode, classItem.id, group, schoolid, bearerToken);
    }
    const gradeNode = DomHelper.appendNode(trNode, "td", [], [], '', `grade-${classItem.id}`);
    const iGradeNode = DomHelper.appendNode(gradeNode, 'i', ['fa-light', 'fa-graduation-cap'], [{
            attr: 'schoolid',
            value: schoolid
        }], "", classItem.id);
    newGroupNode.addEventListener('click', function (event) {
        handleAddGroup2Class(schoolid, classItem.id, bearerToken, event);
    });
    iNode.addEventListener('click', function (event) {
        handleClassEdit(schoolid, classItem, bearerToken, event);
    });
    iNodePrint.addEventListener('click', function (event) {
        handleClassPrintList(schoolid, classItem, bearerToken, event);
    });
    iNodeCSV.addEventListener('click', function (event) {
        handleClassCSVList(schoolid, classItem, bearerToken, event);
    });
    gradeNode.addEventListener('click', function (event) {
        handleGradeShow(schoolid, classItem, bearerToken, event);
    });
}
function renderGridRowClass(parentNode, classItem, schoolid, bearerToken) {
    let cssClassList = [];
    const trNode = DomHelper.appendNode(parentNode, "tr", cssClassList, [], "", classItem.id);
    addClassInfo(trNode, schoolid, classItem, bearerToken);
}
function sortClassesByShortname(classes) {
    const sortedClasses = classes.sort((a, b) => {
        if (a.shortname < b.shortname)
            return -1;
        if (a.shortname > b.shortname)
            return 1;
        return 0;
    });
    return sortedClasses;
}
function appPartClassGridRender(schoolUUID, classes, bearerToken) {
    const messageNode = document.getElementById("odSchoolMessage");
    if (messageNode)
        messageNode.innerHTML = "";
    DomHelper.appendNode(messageNode, 'div', ['rudi-msg-neutral'], [], "In der folgenden Liste sehen Sie alle Klassen Ihrer Schule. Klassen können zeitlich begrenzt werden aber nicht gelöscht werden. <br> Das Kürzel wird zur Anzeige in Listen verwendet und zusammen mit dem Kürzel der Schule wird daraus der Chatraum-Name ermittelt. Das Kürzel ist unveränderlich.");
    const gridNode = document.getElementById("odSchoolGrid");
    if (gridNode) {
        gridNode.innerHTML = "";
        gridNode.setAttribute("schoolid", schoolUUID);
        const tableNode = DomHelper.appendNode(gridNode, "table", [], [], "");
        renderGridClassHeaderRow(tableNode, classes, bearerToken);
        const tbodyNode = DomHelper.appendNode(tableNode, "tbody", [], [], "", 'rudi-class-table-body');
        const sortedClasses = sortClassesByShortname(classes);
        for (let classItem of sortedClasses) {
            renderGridRowClass(tbodyNode, classItem, schoolUUID, bearerToken);
        }
        const buttonAddClassNode = DomHelper.appendNode(gridNode, "button", ['btn', 'btn-secondary'], [], '');
        DomHelper.appendNode(buttonAddClassNode, 'i', ['fa-light', 'fa-plus']);
        DomHelper.appendNode(buttonAddClassNode, 'span', [], [], 'Neue Klasse');
        buttonAddClassNode.addEventListener('click', function (event) {
            handleClassCreate(schoolUUID, bearerToken, event);
        });
    }
}
function appPartSchoolGridRender(schoolUUID, classes, pupils, bearerToken) {
    const sortedClasses = sortClassesByShortname(classes);
    const activeClasses = Util.filterActiveClasses(sortedClasses);
    const messageNode = document.getElementById("odSchoolMessage");
    if (messageNode)
        messageNode.innerHTML = "";
    DomHelper.appendNode(messageNode, 'div', ['rudi-msg-neutral'], [], "In der folgenden Liste sehen Sie alle Lernenden, die noch keiner Klasse zugewiesen sind. Sollte die Liste leer sein klicken Sie auf eine Klassenbezeichnung in der Tabelle um die Lernenden der Klasse anzuzeigen.<br><em>Ein Klick auf einen der Buttons neben den Namen der Lernenden speichert die Klassenzuordnung ohne weitere Dialoge.</em>");
    const gridNode = document.getElementById("odSchoolGrid");
    if (gridNode) {
        gridNode.innerHTML = "";
        gridNode.setAttribute("schoolid", schoolUUID);
        const tableNode = DomHelper.appendNode(gridNode, "table", [], [], "");
        renderGridHeaderRow(tableNode, ['Vorname', 'Name', 'Geb.Datum', 'Geb.Ort'], activeClasses, bearerToken);
        const tbodyNode = DomHelper.appendNode(tableNode, "tbody", [], [], "");
        pupils.sort((a, b) => {
            if (a.sn > b.sn)
                return 1;
            else if (a.sn < b.sn)
                return -1;
            else
                return 0;
        });
        for (let pupil of pupils) {
            renderGridRow(tbodyNode, activeClasses, pupil, bearerToken);
        }
    }
}
function appPartSchoolGridClassRender(schoolUUID, groups, pupils, bearerToken) {
    const sortedGroups = sortClassesByShortname(groups);
    const activeGroups = Util.filterActiveClasses(sortedGroups);
    const messageNode = document.getElementById("odSchoolMessage");
    if (messageNode)
        messageNode.innerHTML = "";
    DomHelper.appendNode(messageNode, 'div', ['rudi-msg-neutral'], [], "In der folgenden Liste sehen Sie alle Lernenden, die noch keiner Gruppe zugewiesen sind. Sollte die Liste leer sein klicken Sie auf eine Gruppennbezeichnung in der Tabelle um die Lernenden der Gruppe anzuzeigen.<br><em>Ein Klick auf einen der Buttons neben den Namen der Lernenden speichert die Gruppenzuordnung ohne weitere Dialoge.</em>");
    const gridNode = document.getElementById("odSchoolGrid");
    if (gridNode) {
        gridNode.innerHTML = "";
        gridNode.setAttribute("schoolid", schoolUUID);
        const tableNode = DomHelper.appendNode(gridNode, "table", [], [], "");
        renderGridHeaderGroupRow(tableNode, ['Vorname', 'Name', 'Geb.Datum'], activeGroups, bearerToken);
        const tbodyNode = DomHelper.appendNode(tableNode, "tbody", [], [], "");
        pupils.sort((a, b) => {
            if (a.sn > b.sn)
                return 1;
            else if (a.sn < b.sn)
                return -1;
            else
                return 0;
        });
        for (let pupil of pupils) {
            renderGroupGridRow(tbodyNode, activeGroups, pupil, bearerToken);
        }
    }
}
function appPartSchoolTeacherGridRender(schoolUUID, classes, teachers, bearerToken) {
    const sortedClasses = sortClassesByShortname(classes);
    const activeClasses = Util.filterActiveClasses(sortedClasses);
    const messageNode = document.getElementById("odSchoolMessage");
    if (messageNode)
        messageNode.innerHTML = "";
    DomHelper.appendNode(messageNode, 'div', ['rudi-msg-neutral'], [], "In der folgenden Liste sehen Sie alle Personen, die in der BOM Ihrer Schule zugeordnet sind. Klicken Sie auf eine Klassenbezeichnung um eine Person der Klasse zuzuweisen.<br>Diese Information dient z.B. der Zuordnung zu Chatgruppen.<br><em>Ein Klick auf einen der Buttons speichert die Klassenzuordnung ohne weitere Dialoge.</em><br><em>Ein Klick auf einen bereits markierten Buttons löscht die Klassenzuordnung ohne weitere Dialoge.</em>");
    const gridNode = document.getElementById("odSchoolGrid");
    if (gridNode) {
        gridNode.innerHTML = "";
        gridNode.setAttribute("schoolid", schoolUUID);
        const tableNode = DomHelper.appendNode(gridNode, "table", [], [], "");
        renderGridHeaderRow(tableNode, ['Vorname', 'Name'], activeClasses, bearerToken);
        const tbodyNode = DomHelper.appendNode(tableNode, "tbody", [], [], "");
        teachers.sort((a, b) => {
            if (a.sn > b.sn)
                return 1;
            else if (a.sn < b.sn)
                return -1;
            else
                return 0;
        });
        for (let teacher of teachers) {
            renderTeacherGridRow(tbodyNode, activeClasses, teacher, bearerToken);
        }
    }
}
function renderFunctionButton(parentNode, selector, schoolUUID, username, bearerToken, activeSelector) {
    let cssClassList = ['rudi-school-class-btn'];
    if (selector.type == activeSelector)
        cssClassList.push("active");
    const buttonNode = DomHelper.appendNode(parentNode, "button", cssClassList, [{
            attr: "schoolid",
            value: schoolUUID
        }], selector.label, selector.type);
    buttonNode.addEventListener('click', function (event) {
        handleFunctionSelection(event, username, bearerToken);
    });
}
function updateFunctionButtonActiveState(activeSelector) {
    const functionNode = document.getElementById("odSchoolFunctionSelector");
    for (let button of functionNode.getElementsByTagName("button")) {
        button.classList.remove('active');
        if (button.getAttribute('id') === activeSelector) {
            button.classList.add('active');
        }
    }
}
function appPartFunctionRender(username, schoolUUID, classes, pupils, bearerToken, activeSelector) {
    const messageNode = document.getElementById("appPartFunctionRender");
    const functionNode = document.getElementById("odSchoolFunctionSelector");
    const classSelectNode = document.getElementById('odSchoolClassSelector');
    if (classSelectNode)
        classSelectNode.innerHTML = '';
    if (functionNode) {
        functionNode.innerHTML = "";
        for (let selector of functionList) {
            renderFunctionButton(functionNode, selector, schoolUUID, username, bearerToken, activeSelector);
        }
    }
}
function renderGridHeaderRow(parentNode, headings, classes, bearerToken) {
    const theadNode = DomHelper.appendNode(parentNode, "thead", [], [], "");
    const trNode = DomHelper.appendNode(theadNode, "tr", [], [], "");
    for (let head of headings)
        DomHelper.appendNode(trNode, "th", [], [], head);
    for (let item of classes) {
        renderGridHeaderRowButtons(trNode, item, bearerToken);
    }
    DomHelper.appendNode(trNode, "td", [], [], "", "status_");
}
function renderGridHeaderGroupRow(parentNode, headings, classes, bearerToken) {
    const theadNode = DomHelper.appendNode(parentNode, "thead", [], [], "");
    const trNode = DomHelper.appendNode(theadNode, "tr", [], [], "");
    for (let head of headings)
        DomHelper.appendNode(trNode, "th", [], [], head);
    for (let item of classes) {
        renderGridHeaderGroupRowButtons(trNode, item, bearerToken);
    }
    DomHelper.appendNode(trNode, "td", [], [], "", "status_");
}
function renderGridClassHeaderRow(parentNode, classes, bearerToken) {
    const theadNode = DomHelper.appendNode(parentNode, "thead", [], [], "");
    const trNode = DomHelper.appendNode(theadNode, "tr", [], [], "");
    DomHelper.appendNode(trNode, "th", [], [], "");
    DomHelper.appendNode(trNode, "th", [], [], "Kürzel");
    DomHelper.appendNode(trNode, "th", [], [], "Name");
    DomHelper.appendNode(trNode, "th", [], [], "Von");
    DomHelper.appendNode(trNode, "th", [], [], "Bis");
    DomHelper.appendNode(trNode, "th", [], [], "Gruppen");
    DomHelper.appendNode(trNode, "th", [], [], "Noten");
}
function renderGridRow(parentNode, classes, pupil, bearerToken, currentClass) {
    let cssClassList = [];
    if (currentClass != null || pupil.odSchoolClass !== currentClass)
        cssClassList.push("disabled");
    const trNode = DomHelper.appendNode(parentNode, "tr", cssClassList, [], "", pupil.cn);
    DomHelper.appendNode(trNode, "td", [], [], pupil.givenName);
    DomHelper.appendNode(trNode, "td", [], [], pupil.sn);
    DomHelper.appendNode(trNode, "td", [], [{ attr: 'title', value: pupil.odPlaceOfBirth + "" }], Util.unixTimestamp2DateString(pupil.odDateOfBirth));
    DomHelper.appendNode(trNode, "td", [], [], pupil.odPlaceOfBirth);
    for (let item of classes) {
        renderGridRowButtons(trNode, item, pupil, bearerToken);
    }
    DomHelper.appendNode(trNode, "td", [], [], "", "status_" + pupil.cn);
}
function renderGroupGridRow(parentNode, groups, pupil, bearerToken, currentClass) {
    let cssClassList = [];
    if (typeof (pupil.odSchoolGroup) != 'undefined' && (currentClass != null || pupil.odSchoolGroup !== currentClass)) {
        const groupExists = groups.some(group => group.id === pupil.odSchoolGroup);
        if (groupExists)
            cssClassList.push("disabled");
    }
    const trNode = DomHelper.appendNode(parentNode, "tr", cssClassList, [], "", pupil.cn);
    DomHelper.appendNode(trNode, "td", [], [], pupil.givenName);
    DomHelper.appendNode(trNode, "td", [], [], pupil.sn);
    DomHelper.appendNode(trNode, "td", [], [], Util.unixTimestamp2DateString(pupil.odDateOfBirth));
    for (let item of groups) {
        renderGridRowGroupButtons(trNode, item, pupil, bearerToken);
    }
    DomHelper.appendNode(trNode, "td", [], [], "", "status_" + pupil.cn);
}
function renderTeacherGridRow(parentNode, classes, pupil, bearerToken, currentClass) {
    let cssClassList = ['default'];
    const trNode = DomHelper.appendNode(parentNode, "tr", cssClassList, [], "", pupil.cn);
    DomHelper.appendNode(trNode, "td", [], [], pupil.givenName);
    DomHelper.appendNode(trNode, "td", [], [], pupil.sn);
    for (let item of classes) {
        renderTeacherGridRowButtons(trNode, item, pupil, bearerToken);
    }
    DomHelper.appendNode(trNode, "td", [], [], "", "status_" + pupil.cn);
}
function renderGridHeaderRowButtons(parentNode, classItem, bearerToken) {
    let cssClassList = ["rudi-school-class-btn", "rudi-school-header"];
    const tdNode = DomHelper.appendNode(parentNode, "th", [], [], "");
    const buttonNode = DomHelper.appendNode(tdNode, "button", cssClassList, [{
            attr: "classid",
            value: classItem.id
        }], classItem.shortname);
    buttonNode.addEventListener('click', function (event) {
        handleClassSelection(event, bearerToken);
    });
}
function renderGridHeaderGroupRowButtons(parentNode, group, bearerToken) {
    let cssClassList = ["rudi-school-group-btn", "rudi-school-header"];
    const tdNode = DomHelper.appendNode(parentNode, "th", [], [], "");
    const buttonNode = DomHelper.appendNode(tdNode, "button", cssClassList, [{
            attr: "groupid",
            value: group.id
        }], group.shortname);
    buttonNode.addEventListener('click', function (event) {
        handleGroupSelection(event, bearerToken);
    });
}
function isInSchoolClass(teacher, classUUID) {
    return teacher.classes.some(item => item.id === classUUID);
}
function renderGridRowButtons(parentNode, classItem, pupil, bearerToken) {
    let cssClassList = ["rudi-school-class-btn"];
    if (pupil.odSchoolClass === classItem.id) {
        cssClassList.push("active");
    }
    const tdNode = DomHelper.appendNode(parentNode, "td", [], [], "");
    const buttonNode = DomHelper.appendNode(tdNode, "button", cssClassList, [{
            attr: "classid",
            value: classItem.id
        }, { attr: "pupilid", value: pupil.cn }], classItem.shortname);
    buttonNode.addEventListener('click', function (event) {
        putPupil2ClassButtonHandler(event, bearerToken);
    });
}
function renderGridRowGroupButtons(parentNode, group, pupil, bearerToken) {
    let cssClassList = ["rudi-school-group-btn"];
    if (pupil.odSchoolGroup === group.id) {
        cssClassList.push("active");
    }
    const tdNode = DomHelper.appendNode(parentNode, "td", [], [], "");
    const buttonNode = DomHelper.appendNode(tdNode, "button", cssClassList, [{
            attr: "groupid",
            value: group.id
        }, { attr: "pupilid", value: pupil.cn }], group.shortname);
    buttonNode.addEventListener('click', function (event) {
        putPupil2GroupButtonHandler(event, bearerToken);
    });
}
function renderTeacherGridRowButtons(parentNode, classItem, teacher, bearerToken) {
    let cssClassList = ["rudi-school-class-btn"];
    if (isInSchoolClass(teacher, classItem.id)) {
        cssClassList.push("active");
    }
    const tdNode = DomHelper.appendNode(parentNode, "td", [], [], "");
    const buttonNode = DomHelper.appendNode(tdNode, "button", cssClassList, [{
            attr: "classid",
            value: classItem.id
        }, { attr: "teacherid", value: teacher.cn }], classItem.shortname);
    buttonNode.addEventListener('click', function (event) {
        putTeacher2ClassButtonHandler(event, bearerToken);
    });
}
function handleClassSelection(event, bearerToken) {
    if (DEBUG)
        console.log("-->handleClassSelection", event);
    if (event && event.target) {
        let target = event.target;
        const buttonNode = DomHelper.getFirstParentWithClass(target, "rudi-school-class-btn");
        const gridNode = document.getElementById("odSchoolGrid");
        let classid = buttonNode.getAttribute("classid");
        if (gridNode) {
            const theadNode = gridNode.querySelector("thead");
            if (theadNode) {
                const thList = theadNode.getElementsByTagName("th");
                for (let thItem of thList) {
                    const button = thItem.querySelector("button");
                    if (button && button.getAttribute("classid") == classid) {
                        thItem.classList.add("active");
                    }
                    else {
                        thItem.classList.remove("active");
                    }
                }
            }
            const tbodyNode = gridNode.querySelector("tbody");
            if (tbodyNode) {
                for (let row of tbodyNode.children) {
                    const buttonNode = row.querySelector('button.active[classid="' + classid + '"]');
                    if (buttonNode) {
                        row.classList.remove("disabled");
                    }
                    else {
                        row.classList.add("disabled");
                    }
                }
            }
        }
    }
}
function handleGroupSelection(event, bearerToken) {
    if (DEBUG)
        console.log("-->handleClassSelection", event);
    if (event && event.target) {
        let target = event.target;
        const buttonNode = DomHelper.getFirstParentWithClass(target, "rudi-school-group-btn");
        const gridNode = document.getElementById("odSchoolGrid");
        let groupid = buttonNode.getAttribute("groupid");
        if (gridNode) {
            const theadNode = gridNode.querySelector("thead");
            if (theadNode) {
                const thList = theadNode.getElementsByTagName("th");
                for (let thItem of thList) {
                    const button = thItem.querySelector("button");
                    if (button && button.getAttribute("groupid") == groupid) {
                        thItem.classList.add("active");
                    }
                    else {
                        thItem.classList.remove("active");
                    }
                }
            }
            const tbodyNode = gridNode.querySelector("tbody");
            if (tbodyNode) {
                for (let row of tbodyNode.children) {
                    const buttonNode = row.querySelector('button.active[groupid="' + groupid + '"]');
                    if (buttonNode) {
                        row.classList.remove("disabled");
                    }
                    else {
                        row.classList.add("disabled");
                    }
                }
            }
        }
    }
}
function putTeacher2ClassButtonHandler(event, bearerToken) {
    if (DEBUG)
        console.log("-->putTeacher2ClassButtonHandler", event);
    if (event && event.target) {
        let target = event.target;
        const buttonNode = DomHelper.getFirstParentWithClass(target, "rudi-school-class-btn");
        const gridNode = document.getElementById("odSchoolGrid");
        let schoolid = gridNode != null ? gridNode.getAttribute("schoolid") : "";
        let teacherid = buttonNode.getAttribute("teacherid");
        let classid = buttonNode.getAttribute("classid");
        const tdStatusNode = document.getElementById("status_" + teacherid);
        if (tdStatusNode) {
            let cssClasses = ['fa-light', 'fa-spinner-scale', 'fa-spin', 'fa-2xl'];
            tdStatusNode.innerHTML = "";
            DomHelper.appendNode(tdStatusNode, "i", cssClasses, [], "", "icon_" + teacherid);
            if (buttonNode.classList.contains('active')) {
                getBackendData("", `/school/${schoolid}/class/${classid}/teacher/${teacherid}`, "DELETE", "application/json", bearerToken, putTeacher2ClassResponseHandler);
            }
            else {
                getBackendData("", `/school/${schoolid}/class/${classid}/teacher/${teacherid}`, "PUT", "application/json", bearerToken, putTeacher2ClassResponseHandler);
            }
        }
    }
}
function putTeacher2ClassResponseHandler(response) {
    const responseData = JSON.parse(response.target.response);
    let teacherid = responseData.teacherid;
    let classid = responseData.classid;
    let statusCode = responseData.status;
    const trNode = document.getElementById(teacherid);
    const iconNode = document.getElementById("icon_" + teacherid);
    if (trNode) {
        const activeButton = trNode.querySelector('.rudi-school-class-btn.active');
        const currentButton = trNode.querySelector('button[classid="' + classid + '"]');
        if (currentButton) {
            if (statusCode == '201')
                currentButton.classList.add("active");
            else
                currentButton.classList.remove("active");
        }
    }
    if (iconNode) {
        iconNode.classList.remove("fa-spinner-scale");
        iconNode.classList.remove("fa-spin");
        iconNode.classList.add("fa-check");
    }
}
function putPupil2ClassButtonHandler(event, bearerToken) {
    if (event && event.target) {
        let target = event.target;
        const buttonNode = DomHelper.getFirstParentWithClass(target, "rudi-school-class-btn");
        const gridNode = document.getElementById("odSchoolGrid");
        let schoolid = gridNode != null ? gridNode.getAttribute("schoolid") : "";
        let pupilid = buttonNode.getAttribute("pupilid");
        let classid = buttonNode.getAttribute("classid");
        const tdStatusNode = document.getElementById("status_" + pupilid);
        if (tdStatusNode) {
            let cssClasses = ['fa-light', 'fa-spinner-scale', 'fa-spin', 'fa-2xl'];
            tdStatusNode.innerHTML = "";
            DomHelper.appendNode(tdStatusNode, "i", cssClasses, [], "", "icon_" + pupilid);
            getBackendData("", `/school/${schoolid}/class/${classid}/pupil/${pupilid}`, "PUT", "application/json", bearerToken, putPupil2ClassResponseHandler);
        }
    }
}
function putPupil2GroupButtonHandler(event, bearerToken) {
    if (event && event.target) {
        let target = event.target;
        const buttonNode = DomHelper.getFirstParentWithClass(target, "rudi-school-group-btn");
        const gridNode = document.getElementById("odSchoolGrid");
        let schoolid = gridNode != null ? gridNode.getAttribute("schoolid") : "";
        let pupilid = buttonNode.getAttribute("pupilid");
        let groupid = buttonNode.getAttribute("groupid");
        const tdStatusNode = document.getElementById("status_" + pupilid);
        if (tdStatusNode) {
            let cssClasses = ['fa-light', 'fa-spinner-scale', 'fa-spin', 'fa-2xl'];
            tdStatusNode.innerHTML = "";
            DomHelper.appendNode(tdStatusNode, "i", cssClasses, [], "", "icon_" + pupilid);
            getBackendData("", `/school/${schoolid}/group/${groupid}/pupil/${pupilid}`, "PUT", "application/json", bearerToken, putPupil2GroupResponseHandler);
        }
    }
}
function putPupil2ClassResponseHandler(response) {
    const responseData = JSON.parse(response.target.response);
    let pupilid = responseData.pupilid;
    let classid = responseData.classid;
    const trNode = document.getElementById(pupilid);
    const iconNode = document.getElementById("icon_" + pupilid);
    if (trNode) {
        const activeButton = trNode.querySelector('.rudi-school-class-btn.active');
        if (activeButton)
            activeButton.classList.remove("active");
        const currentButton = trNode.querySelector('button[classid="' + classid + '"]');
        if (currentButton)
            currentButton.classList.add("active");
    }
    if (iconNode) {
        iconNode.classList.remove("fa-spinner-scale");
        iconNode.classList.remove("fa-spin");
        iconNode.classList.add("fa-check");
    }
}
function putPupil2GroupResponseHandler(response) {
    const responseData = JSON.parse(response.target.response);
    let pupilid = responseData.pupilid;
    let groupid = responseData.groupid;
    const trNode = document.getElementById(pupilid);
    const iconNode = document.getElementById("icon_" + pupilid);
    if (trNode) {
        const activeButton = trNode.querySelector('.rudi-school-group-btn.active');
        if (activeButton)
            activeButton.classList.remove("active");
        const currentButton = trNode.querySelector('button[groupid="' + groupid + '"]');
        if (currentButton)
            currentButton.classList.add("active");
    }
    if (iconNode) {
        iconNode.classList.remove("fa-spinner-scale");
        iconNode.classList.remove("fa-spin");
        iconNode.classList.add("fa-check");
    }
}
function createButtonClose(injectNode, username, bearerToken, userPreferences) {
    const buttonNode = DomHelper.appendNode(injectNode, 'button', ['btn', 'btn-primary', 'mt-2'], [{
            attr: 'id',
            value: 'rudi-schooladmin-btn-hide'
        }]);
    DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-arrow-up', 'me-1'], []);
    DomHelper.appendNode(buttonNode, 'span', [], [], 'schließen');
    buttonNode.addEventListener('click', function (event) {
        const appGroupNode = document.getElementById('appGroups');
        if (appGroupNode)
            appGroupNode.classList.remove('disabled');
        const fullScreenNode = document.getElementById('appFullscreen');
        if (fullScreenNode) {
            fullScreenNode.innerHTML = "";
            fullScreenNode.classList.add('disabled');
        }
    });
}
